import React from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

const legendData = {
  precipitation_new: {
    unit: 'mm',
    title: 'Precipitation',
    stops: [
      { color: 'rgba(255, 255, 255, 0)', label: 'None' },
      { color: 'rgba(120, 120, 190, 0.15)', label: 'Very Light' },
      { color: 'rgba(110, 110, 205, 0.3)', label: 'Light' },
      { color: 'rgba(80, 80, 225, 0.7)', label: 'Moderate' },
      { color: 'rgba(20, 20, 255, 0.9)', label: 'Heavy' },
    ],
    // Based on "Classic rain (mm)" from https://openweathermap.org/map_legend
    // stop(0, rgba(225, 200, 100, 0)) or transparent
    // stop(0.5, rgba(120, 120, 190, 0)) 
    // stop(1, rgba(110, 110, 205, 0.3))
    // stop(10, rgba(80,80, 225, 0.7))
    // stop(140, rgba(20, 20, 255, 0.9));
  },
  // clouds_new: { // Removed as per user request
  //   unit: '%',
  //   title: 'Cloudiness',
  //   stops: [
  //     { color: 'rgba(255, 255, 255, 0.0)', label: '0' },
  //     { color: 'rgba(247, 247, 255, 0.5)', label: '50' },
  //     { color: 'rgba(240, 240, 255, 1)', label: '100' },
  //   ],
  //   // Based on "Classic clouds (0-100%)"
  //   // Simplified: stop(0, rgba(255, 255, 255, 0.0))...stop(50, rgba(247, 247, 255, 0.5))...stop(100, rgba(240, 240, 255, 1));
  // },
  temp_new: {
    unit: '°C',
    title: 'Temperature',
    stops: [
      { color: 'rgba(130, 22, 146, 1)', label: '< -30' },
      { color: 'rgba(32, 140, 236, 1)', label: '-20' },
      { color: 'rgba(35, 221, 221, 1)', label: '0' },
      { color: 'rgba(194, 255, 40, 1)', label: '10' },
      { color: 'rgba(255, 240, 40, 1)', label: '20' },
      { color: 'rgba(252, 128, 20, 1)', label: '30+' },
    ],
    // Based on "Temperature (°C)"
    // stop(-30, rgba(130, 87, 219, 1)) - adjusted lower bound representation
    // stop(-20, rgba(32, 140, 236, 1))
    // stop(0, rgba(35, 221, 221, 1))
    // stop(10, rgba(194, 255, 40, 1))
    // stop(20, rgba(255, 240, 40, 1))
    // stop(30, rgba(252, 128, 20, 1)); - adjusted upper bound
  },
  wind_new: {
    unit: 'm/s',
    title: 'Wind Speed',
    stops: [
      { color: 'rgba(255,255,255, 0)', label: '< 1 (Calm)' },
      { color: 'rgba(238,206,206, 0.4)', label: '5 (Light)' },
      { color: 'rgba(179,100,188, 0.7)', label: '15 (Moderate)' },
      { color: 'rgba(63,33,59, 0.8)', label: '25 (Strong)' },
      { color: 'rgba(70,0,175,1)', label: '> 50 (Very Strong)' },
    ],
    // Based on "Wind (m/s)"
    // stop(1, rgba(255,255,255, 0))
    // stop(5, rgba(238,206,206, 0.4))
    // stop(15, rgba(179,100,188, 0.7))
    // stop(25,rgba(63,33,59, 0.8))
    // stop(50, rgba(116,76,172, 0.9)) -> simplified to 25 for brevity
    // stop(100, rgba(70,0,175,1))
  },
};

const WeatherLegend = ({ activeLayerType, weatherLayerOptions }) => {
  if (!activeLayerType || !legendData[activeLayerType]) {
    return null;
  }

  const currentLegend = legendData[activeLayerType];
  const layerDisplayName = weatherLayerOptions[activeLayerType] || currentLegend.title;

  return (
    <Card
      title={`${layerDisplayName} (${currentLegend.unit})`}
      size="small"
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        maxWidth: '200px',
        maxHeight: '300px',
        overflowY: 'auto',
      }}
      bodyStyle={{ padding: '8px' }}
    >
      {currentLegend.stops.map((stop, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
          <div
            style={{
              width: '20px',
              height: '20px',
              backgroundColor: stop.color,
              marginRight: '8px',
              border: '1px solid #ccc',
            }}
          />
          <Text style={{ fontSize: '12px' }}>{stop.label}</Text>
        </div>
      ))}
    </Card>
  );
};

export default WeatherLegend; 